// price format
export function priceFromat(angka, prefix) {
  var numberString = angka.toString().replace(/[^,\d]/g, ''),
  split = numberString.split(','),
  sisa = split[0].length % 3,
  rupiah = split[0].substr(0, sisa),
  ribuan = split[0].substr(sisa).match(/\d{3}/gi)
  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if(ribuan){
    var separator = sisa ? '.' : ''
    rupiah += separator + ribuan.join('.')
  }
  rupiah = split[1] !== undefined ? rupiah + ',' + split[1] : rupiah
  return prefix === undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
}

// gdrive format
export function getGdriveView(url) {
  const dateid = (new Date()).getTime();
  const gdrive = 'https://docs.google.com/gview';
  return gdrive + '?url=' + url + '&embedded=true&dateid=' + dateid;
}